"use client"
import React from 'react'
import Navbar from '../../components/client/common/Navbar'
import MainInvoices from "../../components/client/Invoices/MainInvoices"

const Invoices = () => {

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
       <MainInvoices/>
      </main>
    </div>
  )
}

export default Invoices